<template>
  <router-link
    :to="{
      name: nav.targetRouterName,
      params :{versions:nav.versions}
    }"
    class="nav-link-item"
    :class="{sub}"
  >
    <span @touchstart="report(nav.targetRouterName, nav.name)">
      {{ nav.name }}</span>
    <b
      v-if="tabRedPointInfo.num > 0"
      class="red-point"
      :class="{
        on: tabRedPointInfo.num > 0,
        num: tabRedPointInfo.type === 'number',
      }"
    >{{ tabRedPointInfo.num }}</b>
  </router-link>
</template>

<script>
import { isEmpty } from '@tencent/slug-function';

export default {
  props: {
    // 是否为顶部二级导航
    sub: {
      type: Boolean,
      default: false,
    },
    // 当前nav
    nav: {
      type: Object,
      required: true,
      default: () => ({ targetRouterName: '', name: '' }),
    },
  },
  computed: {
    // 顶部导航 红点
    redPointTopTab() {
      return this.$store.getters.redPointTopTab;
    },
    // 顶部二级导航 红点
    redPointSubTab() {
      return this.$store.getters.redPointSubTab;
    },
    // 根据tab，获取红点信息
    tabRedPointInfo() {
      const { targetRouterName } = this.nav;
      const keyName = this.sub ? 'redPointSubTab' : 'redPointTopTab';
      const defaultRedPointInfo = {
        type: 'general',
        num: 0,
      };
      const currentRedPointInfo = this[keyName][targetRouterName];

      return isEmpty(currentRedPointInfo) ? defaultRedPointInfo : currentRedPointInfo;
    },
  },
  methods: {
    report(ename, cname) {
      PTTSendClick('btn', ename, cname);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
